import {
  Address,
  AustralianState,
  LocalityAddress,
  PostalAddress,
} from 'scenes/common/types';
import { toCapitalCase } from 'scenes/common/helpers/text';

import { removeDoubleSpace } from 'scenes/common/helpers/string';
import { ADDRESS_ID, DIFFERENT_ADDRESS_ID } from './ids';
import { WireAddress } from '../types';

const toStreetName = (str: string): string =>
  str.split(' ').slice(0, -1).join(' ');

const toStreetSuffix = (str: string): string =>
  str.split(' ').slice(-1).toString();

export const toWireMainAddress = ({
  suburb,
  state,
  postcode,
  streetName,
  streetSuffix,
  gnaf,
  unitNo,
  houseNo,
  latitude,
  longitude,
  addressLine1,
}: Address): WireAddress => ({
  id: ADDRESS_ID,
  suburb,
  state,
  postcode,
  gnaf,
  streetName: toCapitalCase(`${streetName} ${streetSuffix}`),
  fullName: addressLine1,
  streetNumber: houseNo || '',
  unitNumber: unitNo || '',
  latitude: latitude.toString(),
  longitude: longitude.toString(),
});

export const toWirePostalAddress = ({
  suburb,
  state,
  postcode,
  streetName,
  streetSuffix,
  gnaf,
  unitNo,
  houseNo,
  addressLine1,
  latitude,
  longitude,
}: PostalAddress): WireAddress => ({
  id: DIFFERENT_ADDRESS_ID,
  suburb,
  state,
  postcode,
  fullName: removeDoubleSpace(addressLine1.trim()),
  streetNumber: houseNo?.trim() || '',
  unitNumber: unitNo?.trim() || '',
  streetName:
    streetName && streetSuffix
      ? toCapitalCase(`${streetName?.trim()} ${streetSuffix?.trim()}`)
      : '',
  gnaf: gnaf || '',
  longitude: longitude?.toString() || '',
  latitude: latitude?.toString() || '',
  isPOBox: false,
});

export const toWireLockedBoxAddress = ({
  suburb,
  state,
  postcode,
  addressLine1,
}: LocalityAddress): WireAddress => ({
  id: DIFFERENT_ADDRESS_ID,
  suburb,
  state,
  postcode,
  unitNumber: '',
  streetNumber: '',
  streetName: removeDoubleSpace(addressLine1.trim()),
  gnaf: '',
  longitude: '',
  latitude: '',
  isPOBox: true,
});

export const toMainAddress = (addresses: WireAddress[]): Address => {
  const {
    fullName,
    state,
    postcode,
    gnaf,
    streetNumber,
    latitude,
    longitude,
    streetName,
    suburb,
    unitNumber,
  } = addresses.find((addr) => addr.id === 'Addr-0') as WireAddress;

  return {
    address: `${fullName}\n${suburb}\n${state}\n${postcode}`,
    addressLine1: fullName || '',
    addressLine2: '',
    gnaf,
    houseNo: streetNumber,
    latitude: parseFloat(latitude),
    longitude: parseFloat(longitude),
    lotNo: '',
    postcode,
    state: AustralianState[state],
    streetName: toStreetName(streetName),
    streetPrefix: '',
    streetSuffix: toStreetSuffix(streetName),
    suburb,
    unitNo: unitNumber,
  };
};
